import Header from "../Header";
import About from "../About";
import Features from "../Features";
import Screenshots from "../Screenshots";
import Download from "../Download";
import Categories from "../Categories";

const Home = () => {
	return (
		<>
			<Header />
			<Categories />
			<Download />
			<About />
			<Features />
			<Screenshots />
			{/* <Privacy /> */}
		</>
	);
};
export default Home;
